
function GetParameterValues(param) {

    var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < url.length; i++) {
        var urlparam = url[i].split('=');
        if (urlparam[0] == param) {
            return urlparam[1];
        }
    }
}

//QueryString
function getUrlParameter(name) {

    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};


function showLoader() {
    $("#outer-loader").show(); //loader
}

function hideLoader() {
    $("#outer-loader").hide(); //loader
}

function validateEmail(email) {

    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function validateCell(cellNo) {

    // return (cell[0] == "+" && cell.replace(/\s/g, "").length > 11)
    //return (cell[0] == "0" && cell.replace(/\s/g, "").length == 10)
    return (cellNo[0] === "0" && cellNo.replace(/\s/g, "").length === 10 && isNaN(cellNo) === false);
}

function validateID(idNum) {

    var ex = /^(((\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8])))|([02468][048]|[13579][26])0229))(( |-)(\d{4})( |-)(\d{3})|(\d{7}))/;

    if (ex.test(idNum) == false) {
        return false;
    }
    else {
        return checkID(idNum);
    }
}

function checkID(idnum) {

    var idchars = idnum.toString().split('');
    var sum = 0;
    for (var i = 1; i <= idchars.length; i++) {
        var digit = parseInt(idchars[idchars.length - i]);
        console.log(digit);
        if ((i % 2) != 0) {
            sum += digit;
            console.log("sum is: " + sum);
        } else {
            sum += digit < 5 ? digit * 2 : digit * 2 - 9;
            console.log("sum is: " + sum);
        }
    }
    return (sum % 10) == 0;
}

function initMap() {
    let autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("deliveryStreetAddressAutocomplete"),
        {
            componentRestrictions: {
                country: "za"
            }
        }
    );
    autocomplete.addListener("place_changed", function () { fillInDeliveryAddress(autocomplete) });

    if (getUrlParameter('lat') != "") // no map data - might be part of the "Shop" journey
    {
        var geocoder = new google.maps.Geocoder;
        geocodeLatLng(geocoder);
    }
}


function fillInDeliveryAddress(autocomplete) {

    var e = autocomplete.getPlace();

    components = e.address_components;
    let address = '', suburb = "", city = "", province = "", country = "", postalCode = "", possSuburb = "";
    for (var i = 0, component; component = components[i]; i++) {
        if (component.types[0] == 'street_number') {
            address = component['long_name'];
        }

        if (component.types[0] == 'route') {
            address += " " + component['long_name']
        }

        if (component.types[1] == 'sublocality') {
            possSuburb = component['long_name'];
        }

        if (component.types[0] == 'locality') {
            suburb = component['long_name'];
        }

        if (component.types[0] == 'administrative_area_level_2') {
            city = component['long_name'];
            if (city == suburb) {
                suburb = possSuburb;
            } else {
                address += ', ' + possSuburb;
            }
        }

        if (component.types[0] == 'administrative_area_level_1') {
            province = component['long_name'];
        }

        if (component.types[0] == 'country') {
            country = component['long_name'];
        }

        if (component.types[0] == 'postal_code') {
            postalCode = component['long_name'];
        }
    }

    $("#deliveryStreetAddress").val(address);

    $("#deliverySuburb").val(suburb);
    $("#deliveryCity").val(city);
    $("#deliveryProvince").val(province);
    $("#deliveryPostalCode").val(postalCode);
}

function geocodeLatLng(geocoder) {


    let latstr = parseFloat(getUrlParameter('lat'));
    let longstr = parseFloat(getUrlParameter('lon'));
    localStorage.setItem('latlong', latstr + ',' + longstr);

    var latlng = { lat: latstr, lng: longstr };
    geocoder.geocode({ 'location': latlng }, function (results, status) {
        if (status === 'OK') {
            if (results[0]) {
                let components = results[0].address_components;
                var address = '', suburb = "", city = "", province = "", country = "", postalCode = "", longAddress = "";
                for (var i = 0, component; component = components[i]; i++) {

                    if (component.types[0] == 'street_number') {
                        address = component['long_name'];
                    }
                    if (component.types[0] == 'route') {
                        address = address + ',' + component['long_name']
                    }
                    if (component.types[1] == 'sublocality') {
                        address = address + ',' + component['long_name']
                    }
                    if (component.types[0] == 'locality') {
                        $('#userSuburb').val(component['long_name']);
                        suburb = component['long_name'];
                    }
                    if (component.types[0] == 'administrative_area_level_2') {
                        $('#userCity').val(component['long_name']);
                        city = component['long_name'];
                    }
                    if (component.types[0] == 'administrative_area_level_1') {
                        $('#userProvince').val(component['long_name']);
                        province = component['long_name'];
                    }
                    if (component.types[0] == 'country') {
                        $('#userCountry').val(component['long_name']);
                        country = component['long_name'];
                    }
                    if (component.types[0] == 'postal_code') {
                        $('#userPostalCode').val(component['long_name']);
                        postalCode = component['long_name'];
                    }
                }
                address = address.replace(/^,|,$/g, '')
                $('#userAddressHome').val(address);

                longAddress = address.replace(/,/gm, ", ");
                if (suburb != city) { longAddress += "<br/>" + suburb; }
                longAddress += "<br/>" + city;
                longAddress += "<br/>" + province;
                longAddress += "<br/>" + postalCode;
                $('#userAddressHomeFull').html(longAddress);

            } else {
                window.alert('No results found');
            }
        } else {
            window.alert('Geocoder failed due to: ' + status);
        }
    });
}

function showInnerLoader() {

    $("#inner-loader").show();
}

function hideInnerLoader() {

    $("#inner-loader").hide();
}

function getServiceProviders() {

    let nos = getUrlParameter("nos");

    if (nos.toLowerCase().indexOf("wan:waterfall-valley-estate") > -1)
        return 'Waterfall Valley (WAN)';

    for (var e = "", t = nos.split(","), r = 0; r < t.length; r++) {
        var a = t[r].split(":")[0];

        "Vumatel" == a ? a = "VumaTel" : "OS" == a ? a = "Openserve" : "SV" == a ? a = "Supersonic" : "MTN" == a ? a = "Supersonic" : "MFN" == a ? a = "Metrofibre" : "SADV" == a ? a = "SADV" : "Octotel" == a ? a = "Octotel" : "Mitchell" == a ? a = "VumaReach" : "VumaReach" == a ? a = "VumaReach" : "Vodacom" == a ? a = "Vodacom" : "Balwin" == a ? a = "Balwin" : "LinkAfrica" == a ? a = "Link Africa" : "LinkAfrica" == a ? a = "Link Africa" : "Evotel" == a ? a = "Evotel" : "ClearAccess" == a ? a = "ClearAccess" : "Lightstruck" == a ? a = "Lightstruck" : "WAN" == a ? a = "Waterfall Access Networks" : "LinkLayer" == a ? a = "LinkLayer" : "Frogfoot" == a && (a = "Frogfoot"),
            e = e + "," + a
    }
    return e.replace(/^,|,$/g, "");
}

function applyTemplate(templateHtml, dictionary) {

    function escapeRegExp(string) {
        return string.replace(/[.*+\-?^${}()|[\]\\]/gm, '\\$&'); // $& means the whole matched string
    }

    let str = templateHtml;
    for (let i = 0; i < dictionary.length; i++) {
        let item = dictionary[i];
        str = str.replace(new RegExp(escapeRegExp(item.key), 'g'), item.value);
    }
    return str;
}

function getDevicesCountBasedOnDescription(description) {

    return description.includes("Bundle") ? 3 : 1
}

function initTopTouchBar() {
    //touched for mobile
    var ts;
    $(document).bind('touchstart', function (e) {
        ts = e.originalEvent.touches[0].clientY;
    });

    $(document).bind('touchend', function (e) {
        var te = e.originalEvent.changedTouches[0].clientY;
        if (ts > te + 5) {

            $("#button-check").css("display", "inline-block").css("position", "sticky");
            $("#header").css("position", "fixed").css("display", "none");
            $("#button-check-down").css("display", "none");
            console.log('down')
        } else if (ts < te - 5) {
            $("#button-check").css("display", "none").css("position", "sticky");

            $("#header").css("position", "sticky").css("display", "inline-block");
            $("#button-check-down").css("display", "inline-block").css("position", "sticky");
            console.log('up')
        }
    });
}

function initSelects() {

    //CUSTOM SELECT
    $('select').not(".select-hidden").each(function () {
        var $this = $(this), numberOfOptions = $(this).children('option').length;

        if (numberOfOptions == 2) {
            $(this).children('option').remove("[data-hide='hide']");
        }

        $this.addClass('select-hidden');
        $this.wrap('<div class="select"></div>');
        $this.after('<div class="select-styled"></div>');

        var $styledSelect = $this.next('div.select-styled');
        $styledSelect.text($this.children('option').eq(0).text());

        var $list = $('<ul />', {
            'class': 'select-options'
        }).insertAfter($styledSelect);


        for (var i = 0; i < numberOfOptions; i++) {

            
                if (!$this.children('option').eq(i).prop('disabled')) {
                    $('<li />', {
                        text: $this.children('option').eq(i).text(),
                        rel: $this.children('option').eq(i).val(),
                        'data-hide': $this.children('option').eq(i).data("hide"),

                    }).appendTo($list);
                }
                else {
                    $('<li />', {
                        class: "separator",
                        rel: ""
                    }).appendTo($list);
                }
            
        }


        var $listItems = $list.children('li');

        $styledSelect.click(function (e) {
            e.stopPropagation();
            $('div.select-styled.active').not(this).each(function () {
                $(this).removeClass('active').next('ul.select-options').hide();
            });
            $(this).toggleClass('active').next('ul.select-options').toggle();

        });

        $listItems.click(function (e) {
            e.stopPropagation();
            if ($(this).attr('rel') != null && $(this).attr('rel') != "") {
            $styledSelect.text($(this).text()).removeClass('active');
            $this.val($(this).attr('rel'));
            $this.trigger("change");
            $list.hide();
            if ($this.valid) {
                $this.valid();
            }
            //console.log($this.val());
        }
    });

    $(document).click(function () {
        $styledSelect.removeClass('active');
        $list.hide();
    });

});
}


